// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__65dlu","breadcrumbs":"styles_breadcrumbs__6bIRY","title":"styles_title__2oSCR"};